import { useQuery } from '@tanstack/react-query';
import { productKeys, type ProductListQuery } from '@/services/queryKeys';
import { productService } from '@/services/product.service';

export function useProductList(query: ProductListQuery = {}) {
  return useQuery({
    queryKey: productKeys.list(query),
    queryFn: () => productService.list(query),
    placeholderData: (prev) => prev,
    retry: 0,
  });
}
